import React from "react";
import {
  Link
} from "react-router-dom";

import config from './../../config.js';

import Loading from './../../../components/loading.js';
import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
  style: {
    top: '45px',
    right: 0
  }
}, (n) => notification = n);

export default class ConfigSite extends React.Component {
  constructor(props) {
    super(props);
    let user = {};
    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
    }

    this.state = {
      page_title: '网站设置',
      user: user,
      loading: false,
      site: []
    };

    document.title = this.state.page_title;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }
  componentDidMount() {
    this.getSiteinfo();
  }

  getSiteinfo() {
    const me = this;
    const {
      user
    } = me.state;
    const postdata = {
      type: 'siteinfo',
      managerlevel: user.level,
      companyid: user.company_id,
      Authorization: localStorage.token
    };
    fetch(config.host + '/manager/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1) {
          me.setState({
            site: json.data
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }



  handleInputChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    let {
      site
    } = this.state;

    this.setState({
      site: Object.assign(site, {
        [name]: value
      })
    });
  }



  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    const me = this;
    const {
      user,
      site
    } = me.state;
    const postdata = Object.assign(site, {
      type: 'update_site',
      managerlevel: user.level,
      companyid: user.company_id,
      Authorization: localStorage.token
    });
    me.setState({
      loading: true
    });
    fetch(config.host + '/manager/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        me.notify(json.message);

        me.setState({
          loading: false
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }



  notify(message) {
    notification.notice({
      content: <span>{message}</span>,
      duration: 4,
      style: {
        'bottom': 0,
        'right': 0
      }
    });
  }


  render() {
    let {
      site
    } = this.state;
    return (
      <div>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 ">
        <h3>{this.state.page_title}</h3>
      </div>
      
      <form  onSubmit={this.handleSubmit}>
          <div className="form-group">
            <label>电子邮箱</label>
            <input type="email" className="form-control" placeholder="Email" name="email" value={site.email || ''} required onChange={this.handleInputChange} />
          </div>
          <div className="form-group">
            <label>名称</label>
            <input type="text" name="name" className="form-control"  placeholder="Site name" value={site.name || ''} required onChange={this.handleInputChange} />
          </div>

          <div className="form-group">
            <label>地址</label>
            <input type="text" name="address" className="form-control"  placeholder="Address" value={site.address || ''} required onChange={this.handleInputChange} />
          </div>
          <div className="form-group">
            <label>电话</label>
            <input type="text" name="telephone" className="form-control"  placeholder="Telephone" value={site.telephone || ''} onChange={this.handleInputChange} />
          </div>

          <div className="form-group">
            <label>工作日</label>
            <input type="text" name="workingday" className="form-control"  placeholder="Working day" value={site.workingday || ''} onChange={this.handleInputChange} />
          </div>

          <div className="form-group">
            <label>描述</label>
            <textarea name="description" cols="30" rows="10" value={site.description || ''} onChange={this.handleInputChange} className="form-control" ></textarea>
          </div>

          <button type="submit" className="btn btn-primary" title="Submit">保 存</button>
        </form>
      </div>


    );
  }
}


// WEBPACK FOOTER //
// ./src/apps/console/manager/config_site.js